import { DirectionsRenderer, GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { Spin } from 'antd';
import { Colors } from 'core/interfaces/variables.types';
import { getRouteStore } from 'core/modules/routes/route.store';
import { useEffect, useMemo } from 'react';
import { config } from 'src/config';
import { transformRawRouteResponseToDirections } from 'src/utils/maps';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var libraries = ['places', 'geometry'];
var DEFAULT_STYLE = {
  width: '550px',
  height: '550px',
  backgroundColor: Colors.lightGrey
};
export var RouteDirectionsMapView = function RouteDirectionsMapView(_ref) {
  var plan = _ref.plan;

  var _getRouteStore = getRouteStore(),
      rawDataById = _getRouteStore.rawDataById,
      assertGoogleMapsId = _getRouteStore.assertGoogleMapsId;

  var _useJsApiLoader = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.googleMapsApiKey,
    libraries: libraries
  }),
      isLoaded = _useJsApiLoader.isLoaded;

  var rawData = rawDataById(plan.googleMapsId);
  var map = useMemo(function () {
    return isLoaded && /*#__PURE__*/_jsx(GoogleMap, {
      mapContainerStyle: DEFAULT_STYLE,
      options: {
        minZoom: 7,
        maxZoom: 15,
        disableDefaultUI: true
      },
      children: (rawData === null || rawData === void 0 ? void 0 : rawData.googleMaps) && /*#__PURE__*/_jsx(DirectionsRenderer, {
        options: {
          directions: transformRawRouteResponseToDirections(rawData) // suppressMarkers: true,

        }
      })
    });
  }, [isLoaded, plan.googleMapsId, !!(rawData !== null && rawData !== void 0 && rawData.googleMaps)]);
  useEffect(function () {
    assertGoogleMapsId(plan.googleMapsId);
  }, [plan.googleMapsId]);

  if (!isLoaded || !rawData) {
    return /*#__PURE__*/_jsx(Loading, {
      children: /*#__PURE__*/_jsx(Spin, {})
    });
  }

  return map;
};
var Loading = styled.div.withConfig({
  displayName: "DirectionsMap__Loading",
  componentId: "sc-1nwed03-0"
})(["width:550px;height:550px;background-color:", ";display:flex;align-items:center;justify-content:center;"], Colors.lightGrey);